import * as bootstrap from 'bootstrap';
import './omani-ui.js';
window.bootstrap = bootstrap;
export { bootstrap };
